/**
 * @fileoverview GET handler for the "/engagement/campaigns/campaign_territories" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementCampaignsCampaignTerritories } from "./constants";
import type {
  EngagementCampaignsCampaignTerritoriesResult,
  EngagementCampaignsCampaignTerritoriesParams,
} from "./types";

export const getEngagementCampaignsCampaignTerritories = reactQueryFetcherAdapter(
  engagementCampaignsCampaignTerritories,
  (
    signal: AbortSignal,
    { appGroupId }: EngagementCampaignsCampaignTerritoriesParams
  ): Promise<EngagementCampaignsCampaignTerritoriesResult> => {
    return fetch("/engagement/campaigns/campaign_territories", "GET", { app_group_id: appGroupId }, { signal });
  }
);
